import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import RhPropertyInfo from '../json-pages/RhPropertyInfo';
import RhPrimaryDialog from '../json-pages/RhPrimaryDialog';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/information`} component={RhPropertyInfo} />
      <Route path={`${match.url}/primary`} component={RhPrimaryDialog} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
